// Gerar ID único para execuções
const generateExecutionId = () => `exec_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

// Constantes para cálculo de tempo estimado (em ms)
const TIME_ESTIMATES = {
  send_message: (content) => {
    // 50ms por caractere + 500ms base
    const text = content?.[0] || '';
    return Math.min(text.length * 50 + 500, 5000);
  },
  send_attachment: () => 3000, // 3 segundos para anexo
  add_private_note: (content) => {
    const text = content?.[0] || '';
    return Math.min(text.length * 30 + 300, 3000);
  },
  assign_team: () => 200,
  assign_agent: () => 200,
  add_label: () => 200,
  remove_label: () => 200,
  remove_assigned_team: () => 200,
  mute_conversation: () => 200,
  snooze_conversation: () => 200,
  resolve_conversation: () => 200,
  change_priority: () => 200,
  send_email_transcript: () => 1000,
  send_webhook_event: () => 500,
  wait: (params) => {
    // Tempo de espera em segundos, convertido para ms
    const seconds = parseInt(params?.[0] || 0, 10);
    return seconds * 1000;
  },
};

// Calcular tempo total estimado de uma macro
const calculateMacroTotalTime = (actions) => {
  return actions.reduce((total, action) => {
    const estimator = TIME_ESTIMATES[action.action_name];
    if (estimator) {
      return total + estimator(action.action_params);
    }
    return total + 200; // default 200ms
  }, 0);
};

const state = {
  executions: [],
};

const getters = {
  getExecutions: ($state) => $state.executions,
  getActiveExecutions: ($state) => 
    $state.executions.filter(e => e.status === 'running'),
  getExecutionCount: ($state) => $state.executions.length,
  getActiveCount: ($state) => 
    $state.executions.filter(e => e.status === 'running').length,
};

const mutations = {
  ADD_EXECUTION(state, execution) {
    state.executions.unshift(execution);
  },
  UPDATE_EXECUTION(state, { id, updates }) {
    const index = state.executions.findIndex(e => e.id === id);
    if (index !== -1) {
      state.executions[index] = { ...state.executions[index], ...updates };
    }
  },
  REMOVE_EXECUTION(state, id) {
    state.executions = state.executions.filter(e => e.id !== id);
  },
  CLEAR_COMPLETED(state) {
    state.executions = state.executions.filter(e => e.status === 'running');
  },
};

const actions = {
  // Adicionar uma nova execução à fila
  addExecution({ commit }, { macro, conversation, user }) {
    const totalTime = calculateMacroTotalTime(macro.actions);
    
    const execution = {
      id: generateExecutionId(),
      macroId: macro.id,
      macroName: macro.name,
      conversationId: conversation.id,
      conversationDisplayId: conversation.display_id,
      contactName: conversation.meta?.sender?.name || 'Contato',
      contactAvatar: conversation.meta?.sender?.thumbnail,
      userId: user.id,
      userName: user.name,
      actions: macro.actions,
      totalTime,
      startedAt: Date.now(),
      status: 'running',
      progress: 0,
    };
    
    commit('ADD_EXECUTION', execution);
    
    // Iniciar timer para atualizar progresso
    const intervalId = setInterval(() => {
      const elapsed = Date.now() - execution.startedAt;
      const progress = Math.min((elapsed / totalTime) * 100, 100);
      
      commit('UPDATE_EXECUTION', { 
        id: execution.id, 
        updates: { progress } 
      });
      
      // Quando atingir 100%, marcar como completado
      if (progress >= 100) {
        clearInterval(intervalId);
        commit('UPDATE_EXECUTION', { 
          id: execution.id, 
          updates: { status: 'completed' } 
        });
        
        // Remover após 3 segundos
        setTimeout(() => {
          commit('REMOVE_EXECUTION', execution.id);
        }, 3000);
      }
    }, 100); // Atualizar a cada 100ms
    
    return execution.id;
  },
  
  // Remover uma execução manualmente
  removeExecution({ commit }, id) {
    commit('REMOVE_EXECUTION', id);
  },
  
  // Limpar execuções completadas
  clearCompleted({ commit }) {
    commit('CLEAR_COMPLETED');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
